/**
 * List of known extension keys for the bucket
 */ export var BucketExtensionKeys = /*#__PURE__*/ function(BucketExtensionKeys) {
    /** The extension with legacy data for legacy basic entities */ BucketExtensionKeys["legacyData"] = "LegacyData";
    return BucketExtensionKeys;
}({});
